/**
 * BetterBLOX — Roblox site enhancer
 *
 * Declares one web-accessible-resource entry matched to every http(s) origin with no
 * `use_dynamic_url`, listing `icons/svg/*.svg`, `icons/png/*.png`, `changelog.json`,
 * `styles/tailwind.css` and `options.html`. Each resolves at a fixed URL from any page.
 *
 * The `icons/png/filter.png` image is the primary signal — `probeImage` reaches it with
 * no CORS grant — corroborated by the distinctive `changelog.json` and a vendor-named
 * SVG icon. All fire only when the extension is installed.
 *
 * Manifest verified against version 2.7.3.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lplhnhhlblehjmmkcpjbojiaanbpgnpd';

export const betterblox: ExtensionDefinition = {
  id: ID,
  name: 'BetterBLOX - Better Roblox Extension',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'One static WAR on every http(s) origin covering its icons, changelog and styles, ' +
    'with no dynamic URL. Detection is conclusive and CORS-free.',
  signals: [
    {
      id: 'war-filter-png',
      kind: 'web-accessible-resource',
      description:
        'Load icons/png/filter.png via <img> — exposed to every origin and readable ' +
        'without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'icons/png/filter.png'),
    },
    {
      id: 'war-changelog-json',
      kind: 'web-accessible-resource',
      description: 'Fetch changelog.json — a named data file exposed as a WAR, an independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'changelog.json'),
    },
    {
      id: 'war-smallest-server-svg',
      kind: 'web-accessible-resource',
      description:
        'Load icons/svg/smallest-server.svg via <img> — a vendor-named icon corroborating ' +
        'the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'icons/svg/smallest-server.svg'),
    },
  ],
};
